import {WoolLabSaveToMoodboardModalBlock} from './woolLabSaveToMoodboardModalBlock';

const NS = 'WoolLabImageBlock';
const CLS = 'woolLabImageBlock';
import Handlebars from 'handlebars';

export class WoolLabImageBlock {
	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.id = this.$el.data('id');
		this.$btnAddToMoodboard = this.$el.find(`.${CLS}-btnAddToMoodboard`);
		this.getMoodboardsApi = this.$el.data('getMoodboardsApi');
		this.addToMoodboardApi = this.$el.data('addToMoodboardApi');
		this.createMoodboardApi = this.$el.data('createMoodboardApi');
		this.$image = this.$el.find(`.${CLS}-image`)//.attr(src)

		// Feature flag
		this.featureMoodboardsEnabled = this.$el.data('featureMoodboardsEnabled');

		this.handleButtons();
		this.initFeatureFlags();
	}

	initFeatureFlags() {
		if (!this.featureMoodboardsEnabled) {
			// Hide moodboard button
			this.$btnAddToMoodboard.hide();
		}
	}

	handleButtons() {
		this.$el.on('click', (e) => {
			if ($(e.target).hasClass(`${CLS}-btnAddToMoodboard`)) {
				this.displaySaveToMoodboardModal();
			}
		});
	}

	getSaveToMoodboardModalTemplate() {
        let modalWidget = require('../../partials/widgets/woolLabSaveToMoodboardModalBlock.hbs');

		Handlebars.registerPartial('woolLabSaveToMoodboardModalBlock', modalWidget);

		let template = `
			{{> woolLabSaveToMoodboardModalBlock
				wg="woolLabSaveToMoodboardModalBlock"
				ns="WoolLabSaveToMoodboardModalBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	displaySaveToMoodboardModal() {
		$(document.body).append(this.getSaveToMoodboardModalTemplate());
		let $modal = $('#woolLabSaveToMoodboardModalBlock');

		let modalData = {};
		modalData.getMoodboardsApi = this.getMoodboardsApi;
		modalData.addToMoodboardApi = this.addToMoodboardApi;
		modalData.createMoodboardApi = this.createMoodboardApi;
		modalData.selectedItems = [this.$image.attr('src')];
		modalData.itemType ='image';

		new WoolLabSaveToMoodboardModalBlock($modal[0], modalData);

		$modal.modal('show');
		$('body').css('padding-right', '0');
		$modal.css('padding', '0');

		$modal.on('shown.bs.modal', () => {
			// need to manually add "in" class so backdrop can display properly due to IDS override
			$('.modal-backdrop').addClass('in');
		});

		$modal.on('hidden.bs.modal', () => {
			$modal.remove();
			$('body').css('padding-right', '');
		});
	}
}


